import { render } from "./App.vue?vue&type=template&id=f9e38d72"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/media/gubbi/51C0A8CA04B85949/Ubuntu/home/tp/e-menu/2.0.0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__